import { useSelector } from "react-redux";
import Template1 from "./Template1";
import Template2 from "./Template2";
import Template3 from "./Template3";
import Template4 from "./Template4";
import Template5 from "./Template5";
import Template6 from "./Template6";
import Template7 from "./Template7";
import Template8 from "./Template8";
import Template9 from "./Template9";
import Template10 from "./Template10";
import Template11 from "./Template11";
import Template12 from "./Template12";
import Template13 from "./Template13";
import { useEffect } from "react";
import Template14 from "./Template14";

export default function Templates({ TemplateType }) {
  const userTemplate = useSelector((state) => state.userTemplate);

  let temps = null;

  useEffect(() => {}, [userTemplate]);

  switch (TemplateType) {
    case "temp1":
      temps = <Template1 />;
      break;

    case "temp2":
      temps = <Template2 />;
      break;

    case "temp3":
      temps = <Template3 />;
      break;

    case "temp4":
      temps = <Template4 />;
      break;

    case "temp5":
      temps = <Template5 />;
      break;

    case "temp6":
      temps = <Template6 />;
      break;

    case "temp7":
      temps = <Template7 />;
      break;

    case "temp8":
      temps = <Template8 />;
      break;

    case "temp9":
      temps = <Template9 />;
      break;

    case "temp10":
      temps = <Template10 />;
      break;

    case "temp11":
      temps = <Template11 />;
      break;

    case "temp12":
      temps = <Template12 />;
      break;

    case "temp13":
      temps = <Template13 />;
      break;

    case "temp14":
      temps = <Template14 />;
      break;

    default:
      temps = <Template1 />;
  }

  return temps;
}
